import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import * as _ from "lodash";
import { DatePipe } from '@angular/common';

@Component({
  selector: "app-edit-product",
  templateUrl: "./edit-product.component.html",
  styleUrls: ["./edit-product.component.scss"],
})
export class EditProductComponent implements OnInit {
  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() orgData: ModifyPRDProductReq; //已選資料_來源
  @Input() info: {
    IsLoding:boolean,
    moType: number; //目前編輯狀態 1.新增 2.編輯 3.複製 4.查看
    orgType: number; //來源類型 1.設定檔&設定檔附加品項中 2.菜單檔 3.使用中菜單檔&使用中菜單檔附加品項中 
    pdShowType: number; //1.商品 2.附加品項中商品
    pfType:number;//平台類型 1.POS 2.享online 3.uber 4.panda
    ORG_Store_ID:null
    groupList: selectData[];    
    isChange_Group : boolean;
    PRDGroupNo:null
    PRDMenuProductGroupNo:null
    storeList: selectData[];
    memberTypeList: memberData[];//會員類型清單
    
    //-------old------------
    PRDProductGroupNo: null;
    PRDProductNo: null;
  };
  //標題
  moTitle: string;
  title2: string;
  //主要資料
  mealData: ModifyPRDProductReq;

  //操作者資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  authChangeSub:any;

  //圖片
  testFiles;

  //---------------選項列表-------->--------------//
  //稅率列表
  TaxRateList = [];
  TaxTypeList = [
    { value: 1, content: "免稅" },
    { value: 2, content: "應稅" },
    { value: 3, content: "零稅" },
  ];

  //-------<--------選項列表----------------------//

  @ViewChild("Modal") Modal: TemplateRef<any>;
  modalRef = null; //談窗鉤子
  @ViewChild("DayModal") DayModal: TemplateRef<any>;
  dayModalRef = null; //談窗鉤子

  constructor(
    private http: HttpClient,
    private dialogService: NbDialogService,
    private cookieService: CookieService,
    private datePipe: DatePipe,
  ) {
     this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID')
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID= (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null


    
  }
  
   


  ngOnInit(): void {
    for (let i = 1; i < 100; i++) {
      this.TaxRateList.push({ value: i, content: i + "%" });
    }
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData)

  }


  onOpen(info, data) {
    if (info) this.info = info;

    this.mealData = new ModifyPRDProductReq();
    
    
    if (this.info.moType == 1) {
      this.moTitle = "新增";

      this.mealData.PRDGroupNo = this.info.PRDGroupNo
      this.mealData.PRDMenuProductGroupNo= this.info.PRDMenuProductGroupNo
    }
    else if (this.info.moType == 2) {
      this.moTitle = "編輯";
      if (data) {
        this.toProductDetail(data);
      } 
    }
    else if (this.info.moType == 3) {
      this.moTitle = "複製";
      if (data) {
        this.toProductDetail(data);
        this.mealData.PRDProductNo = null;
      }

      if(this.info.orgType == 1){
        this.getStoreList()
      }

    }
    else if (this.info.moType == 4) {
      this.moTitle = "查看";
      if (data) {
        this.toProductDetail(data);
      } else {
        this.getProductDetail(null);
      }
    }

    if (this.info.orgType == 1) {
      this.title2 = "預設資料";
    }
    else if (this.info.orgType == 2) {
      this.title2 = "可調整資料";
      if(!this.mealData.SupplyQTY)
      this.mealData.SupplyQTY = 10000;
    }
    else if (this.info.orgType == 3) {
      this.title2 = "販售資料";
    }

    if(!info.pdShowType){
      info.pdShowType=1
    }

    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }

  onSave() {
    if (!this.mealData.Cash && this.mealData.Cash != 0) {
      alert("商品原價必須填!");
      return null;
    }
    if (!this.mealData.SaleCash && this.mealData.SaleCash != 0) {
      alert("商品售價必須填!");
      return null;
    }


    //轉換營業時段
    if (this.mealData.supplyPeriod && this.mealData.supplyPeriod.length ) {
      if (this.mealData.supplyPeriod.length >= 1) {
        this.mealData.FirstSupplyStartTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[0].startTime, 'yyyy/MM/dd HH:mm:ss')
        
        this.mealData.FirstSupplyEndTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[0].endTime, 'yyyy/MM/dd HH:mm:ss')

          if(this.mealData.supplyPeriod[0].startTime > this.mealData.supplyPeriod[0].endTime){
            alert("開始日期不可大於結束日期!")
            return 
          }
      }
    
      if (this.mealData.supplyPeriod.length >= 2) {
        this.mealData.SecondSupplyStartTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[1].startTime, 'yyyy/MM/dd HH:mm:ss')
        this.mealData.SecondSupplyEndTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[1].endTime, 'yyyy/MM/dd HH:mm:ss')

          if(this.mealData.supplyPeriod[1].startTime > this.mealData.supplyPeriod[1].endTime){
            alert("開始日期不可大於結束日期!")
            return
          }
      }
    }
    else{
      this.mealData.FirstSupplyStartTime = ""
      this.mealData.FirstSupplyEndTime = ""
      this.mealData.SecondSupplyStartTime = ""
      this.mealData.SecondSupplyEndTime = ""
    }

    var checkMember = null
    if (this.mealData.ProductLevelMapJsonData) {
      checkMember = this.mealData.ProductLevelMapJsonData.map(item => JSON.parse(JSON.stringify(item)));
      for (let i = 0; i < checkMember.length; i++) {
        const item = checkMember[i];
        for (const key in item) {
            if (item[key] === "" || item[key] === null) {
                alert("特殊價格設定未填寫完整!");
                return;
            }
        }
        const ids = item.usrMemberLevelIDs.split(',');
        const names = item.memberLevelNames.split('、');
        if (ids.includes("0") && names.includes("全部適用")) {
            item.usrMemberLevelIDs = null;
            item.memberLevelNames = "";
        }
      }
    }


    //圖片處理
    if (this.mealData.files && this.mealData.files.length > 0) {
      this.mealData.Image = this.mealData.files[0].path;
    }

    //加購品項
    let attachItemGroups: string = "";
    if (this.mealData.AttachItemGroupJsonDatas) {
      let data = _.orderBy(this.mealData.AttachItemGroupJsonDatas,x=>['Sorting'], ['asc'])
      data.forEach((item) => {
        if (attachItemGroups == "") {
          attachItemGroups = item.PRDMenuAttachItemGroupNo;
        } else {
          attachItemGroups = attachItemGroups + "," + item.PRDMenuAttachItemGroupNo;
        }

        item.Sorting = item.Sorting*1
      });
    }
    this.mealData.AttachItemGroupJsonData = attachItemGroups;

    


    //格式處理
    let Main = {
      ProductName: this.mealData.ProductName,
      ProductContant: this.mealData.ProductContant,
      Image: this.mealData.Image,
      TaxRate: this.mealData.TaxRate,
      TaxType: this.mealData.TaxType,
      Cash: this.mealData.Cash,
    }
    let Detail = {
      SaleCash: this.mealData.SaleCash,
      Sorting: this.mealData.Sorting,
      IsOpenTakeout: this.mealData.IsOpenTakeout,
      IsOpenDelivery: this.mealData.IsOpenDelivery,
      IsOpenDining: this.mealData.IsOpenDining,
      IsOpenSelfPickup: this.mealData.IsOpenSelfPickup,
      IsOpenReserveDining: this.mealData.IsOpenReserveDining,
      IsChangeCash:this.mealData.IsChangeCash,
      SupplyQTY: this.mealData.SupplyQTY,
      UplimitQTY: this.mealData.UplimitQTY,
      SupplyDay: this.mealData.SupplyDay,
      FirstSupplyStartTime: this.mealData.FirstSupplyStartTime,
      FirstSupplyEndTime: this.mealData.FirstSupplyEndTime,
      SecondSupplyStartTime: this.mealData.SecondSupplyStartTime,
      SecondSupplyEndTime: this.mealData.SecondSupplyEndTime,
      AttachItemGroupJsonDatas: this.mealData.AttachItemGroupJsonDatas,
      AttachItemGroupJsonData: this.mealData.AttachItemGroupJsonData,
      ProductLevelMapJsonData: checkMember,
    }
    this.mealData.Main = Main
    this.mealData.Detail = Detail
    this.mealData.ORG_Company_ID = this.ORG_Company_ID;
    this.mealData.USR_EmployeeInfo_ID = parseInt(this.USR_EmployeeInfo_ID);
    this.mealData.USR_AccountInfo_ID = this.USR_AccountInfo_ID; //建立者;

    console.log('送出',this.mealData)

    if (this.mealData.TaxType != 2){
      const userConfirmed = confirm("商品稅別非應稅,是否繼續儲存?");
      if (userConfirmed) {
        this.emitList.emit(this.mealData);
      }
      return null;
    }
    this.emitList.emit(this.mealData);
    // this.modalRef.close();
  }


 


  //商品彈窗  新增供應時段
  addSupplyData() {
    if (this.mealData.supplyPeriod == null) {
      this.mealData.supplyPeriod = [];
    }
    if (this.mealData.supplyPeriod.length >= 2) {
      return;
    }
    this.mealData.supplyPeriod.push(new supplyPeriod());
  }

  //商品彈窗  刪除供應時段
  delSupplyData(idx) {
    this.mealData.supplyPeriod.splice(idx, 1);
  }

  //商品彈窗 供應日期 設定
  addSupplyTime() {
    this.dayModalRef = this.dialogService.open(this.DayModal, {});
  }
  //商品彈窗 供應日期 顯示
  showSupplyTime() {
    var str = [];
    var value = [];
    this.mealData.SupplyDay = "";
    if (this.mealData.supplyTimeMonday) {
      str.push("星期一");
      value.push("1");
    }
    if (this.mealData.supplyTimeTuesday) {
      str.push("星期二");
      value.push("2");
    }
    if (this.mealData.supplyTimeWednesday) {
      str.push("星期三");
      value.push("3");
    }
    if (this.mealData.supplyTimeThursday) {
      str.push("星期四");
      value.push("4");
    }
    if (this.mealData.supplyTimeFriday) {
      str.push("星期五");
      value.push("5");
    }
    if (this.mealData.supplyTimeSaturday) {
      str.push("星期六");
      value.push("6");
    }
    if (this.mealData.supplyTimeSunday) {
      str.push("星期日");
      value.push("7");
    }
    if (str.length > 0) {
      //去掉第一個逗號
      this.mealData.supplyDayStr = str.join(",");
      this.mealData.SupplyDay = value.join(",");
    }

    if (this.dayModalRef)
      this.dayModalRef.close()

    return str;
  }

  //商品彈窗 上傳圖片用
  fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = (error) => reject(error);
    });
  };


  //商品彈窗 圖片上傳
  onSelect(event,dataBox) {
    console.log(event);
    dataBox.files = [];

    if (event.addedFiles == null || event.addedFiles.length == 0) {
      return;
    }

    const self = this;
    const checks = event.addedFiles.map(file => {
      return new Promise((resolve, reject) => {
        // 檢查圖片大小
        if (file.size > 20 * 1024 * 1024) {
          alert("檔案大小不能超過20MB");
          return reject();
        }
  
        // 檢查圖片尺寸
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          if (img.width > 2000 || img.height > 2000) {
            alert("圖片的長和寬都要小於2000像素");
            return reject();
          }
          if (img.width < 320 || img.height < 320) {
            alert("圖片的長和寬都要大於320像素");
            return reject();
          }
          resolve(file);
        };
      });
    });
    
    Promise.all(checks).then((validFiles) => {
      dataBox.files.push(event.addedFiles[0]);
      const formData = new FormData();
  
      for (var i = 0; i < dataBox.files.length; i++) {
        formData.append("file[]", dataBox.files[i]);
      }
  
      let imgdata  = {}

      if (dataBox.files && dataBox.files[0]) {
        for (let i = 0; i < dataBox.files.length; i++) {
          self.fileToBase64(dataBox.files[i]).then((result) => {
            const base64String = result;
            
            imgdata = {
              base64: base64String,
              functionType: "1",
              ORG_Company_ID:self.ORG_Company_ID,
              ORG_Store_ID:self.info.ORG_Store_ID
            };
            
            self.info.IsLoding = true;
            self.http
            .post<any>("api/ImageUpload/ImageUpload", imgdata)
            .subscribe({
              next: (data) => {
                console.log(data);
                dataBox.files[0].path = data.path;
                console.log(dataBox.files[0].path);
                self.info.IsLoding = false;
              },
              error: (error) => {
                console.error("There was an error!", error);
              },
            });
          });
        }
      }
    }).catch(() => {
      // 如果有文件不符合要求
      self.info.IsLoding = false;
      console.log("有圖片不符合要求，不執行上傳");
    });
  
  }

  //商品彈窗 圖片清除
  onRemove(event,dataBox) {
    console.log(event);
    // dataBox.files.splice(dataBox.files.indexOf(event), 1);
    dataBox.files = []
    if(dataBox.Image)
      dataBox.Image = ''     
      
    event.stopPropagation();
  }


  //商品彈窗 圖片清除
  Remove(event,dataBox) {
    dataBox.files = []
    if(dataBox.Image)
      dataBox.Image = ''
  }

  //商品彈窗 變更目標商店
  onSelectStore(){
    this.getGroupList()
  }


  //處理商品資料
  toProductDetail(data) {
    
    if(this.info.orgType != 3  ) {
      this.mealData = Object.assign(this.mealData, data,data.Main,data.Detail)
    }
    else{
      this.mealData = Object.assign(this.mealData, data)
    }


    //如果供應時間有值,拆解字串
    if (
      this.mealData.SupplyDay != null &&
      this.mealData.SupplyDay != ""
    ) {
      const myArray = this.mealData.SupplyDay.split(",");
      myArray.forEach((day) => {
        if ("1" == day) {
          this.mealData.supplyTimeMonday = true;
        }
        if ("2" == day) {
          this.mealData.supplyTimeTuesday = true;
        }
        if ("3" == day) {
          this.mealData.supplyTimeWednesday = true;
        }
        if ("4" == day) {
          this.mealData.supplyTimeThursday = true;
        }
        if ("5" == day) {
          this.mealData.supplyTimeFriday = true;
        }
        if ("6" == day) {
          this.mealData.supplyTimeSaturday = true;
        }
        if ("7" == day) {
          this.mealData.supplyTimeSunday = true;
        }
      });
      this.showSupplyTime()
    }
    //填充供應時間
    this.mealData.supplyPeriod = [];
    if (this.mealData.FirstSupplyStartTime != null) {
      var tmp = new supplyPeriod();
      tmp.startTime = new Date(this.mealData.FirstSupplyStartTime);
      tmp.endTime = new Date(this.mealData.FirstSupplyEndTime);
      this.mealData.supplyPeriod.push(tmp);

      if (this.mealData.SecondSupplyStartTime != null) {
        var tmp = new supplyPeriod();
        tmp.startTime = new Date(this.mealData.SecondSupplyStartTime);
        tmp.endTime = new Date(this.mealData.SecondSupplyEndTime);
        this.mealData.supplyPeriod.push(tmp);
      }
    }
  }

  //-----------------------特殊價格設定 >------------------------------
  @ViewChild('ProductLevelSettingMO_Tmp', { static: false }) ProductLevelSettingMO_Tmp
  ProductLevelSettingMO = {
    data: null,           //彈窗的項目(會員類型資料)
    USR_MemberLevel_IDList: null,   //已有的會員
    showData:[],          //顯示的資料
    isShow: false,
    index: null,
    //管理
    onOpen: (data, index) => {
      const self = this;
      let my = self.ProductLevelSettingMO

      my.data = []
      my.data = self.info.memberTypeList
      my.USR_MemberLevel_IDList = []
      if (data.usrMemberLevelIDs && data.usrMemberLevelIDs.trim() !== '') {
        my.USR_MemberLevel_IDList = data.usrMemberLevelIDs.split(',').map(Number);
    } else {
        my.USR_MemberLevel_IDList = [];
    }
      my.index = index
      my.isShow = true
    },   
    onSave: (data) => {
      const self = this;
      let ProductLevel = self.mealData.ProductLevelMapJsonData

      ProductLevel[data.index].usrMemberLevelIDs = data.filteredList.map(member => member.USR_MemberLevel_ID).join(',');
      ProductLevel[data.index].memberLevelNames = data.filteredList.map(member => member.MemberLevelName).join('、');

      // 提取出需要被移除的資料
      const removableNos = data.filteredList.map(member => member.USR_MemberLevel_ID).join(',');
      const removableNames = data.filteredList.map(member => member.MemberLevelName).join('、');

      // 更新 ProductLevel 數組，刪除指定的 USR_MemberLevel_ID 和 MemberLevelName
      ProductLevel.forEach((item, index) => {
        if (index !== data.index) {
            let itemNos = item.usrMemberLevelIDs.split(',');
            let itemNames = item.memberLevelNames.split('、');
    
            // 移除對應的 USR_MemberLevel_ID 和 MemberLevelName
            itemNos = itemNos.filter(no => !removableNos.includes(no));
            itemNames = itemNames.filter(name => !removableNames.includes(name));
    
            // 重新組合回字串格式
            item.usrMemberLevelIDs = itemNos.join(',');
            item.memberLevelNames = itemNames.join('、');
        }
    });
    },
    onDel:(index: number)=>{
      const self = this;
      let ProductLevel = self.mealData.ProductLevelMapJsonData
      ProductLevel.splice(index, 1);
    },
    onClose(v) {
      this.isShow = false
    },
    onAddShow:()=>{  
      const self = this;
      if (!self.mealData.ProductLevelMapJsonData) {
        self.mealData.ProductLevelMapJsonData = [];
      }
      let ProductLevel = self.mealData.ProductLevelMapJsonData
      
      ProductLevel.push({
        usrMemberLevelIDs: '',
        memberLevelNames: '',
        takeoutSaleCash: null,
        deliverySaleCash: null,
        diningSaleCash: null,
        selfPickupSaleCash: null
      }) 
    }
  }

  //附加品項分類  
  @ViewChild('SelectAttMMO_Tmp', { static: false }) SelectAttMMO_Tmp
  SelectAttMMO = {
    info: {
    },
    isShow: false,
    data: null,
    other: {
      attList: [],
    },
    onOpen: () => {
      let my = this.SelectAttMMO
      my.info = {
      }

      my.data = []
      // if (this.mealData.AttachItemGroupJsonDatas){
      //   my.data = _.cloneDeep(this.mealData.AttachItemGroupJsonDatas);
      //   my.data.forEach(x=>{
      //     x.No = x.PRDMenuAttachItemGroupNo 
      //  })
      // }
      my.isShow = true
      //this.SelectAttMMO_Tmp.onOpen(my.info,pdList)
    },
    onSave: (data) => {
      let my = this.SelectAttMMO

      if (!this.mealData.AttachItemGroupJsonDatas)
      this.mealData.AttachItemGroupJsonDatas = []

      let list = []
      data.forEach(p=>{
        if(this.mealData.AttachItemGroupJsonDatas
          .findIndex(x=>x.PRDMenuAttachItemGroupNo==p.No)==-1){
            p.Sorting=0
            list.push(p)
          }
      })
      
      this.mealData.AttachItemGroupJsonDatas =
      this.mealData.AttachItemGroupJsonDatas.concat(list)  
      this.mealData.AttachItemGroupJsonDatas.forEach((item, index) => {
        item.Sorting = index + 1;
      });

    },
    onClose(v) {
      this.isShow = false
    }
  }


  //附加品項群組 選擇
  @ViewChild("SelectAttGMO_Tmp", { static: false }) SelectAttGMO_Tmp;
  SelectAttGM = {
    info: {
      ORG_Company_ID: null,
      ORG_Store_ID: null,
    },
    isShow: false,
    data: null,
    onOpen: () => {
      let my = this.SelectAttGM;
      if (this.mealData.AttachItemGroupJsonDatas)
        my.data = _.cloneDeep(this.mealData.AttachItemGroupJsonDatas);

      my.info = {
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: this.ORG_Store_ID,
      }
      //this.SelectAttGMO_Tmp.onOpen(my.info, my.data);
      my.isShow = true
    },
    onSave: (data) => {
      let my = this.SelectAttGM;
      this.mealData.AttachItemGroupJsonDatas = data
    },
    onClose(v) {
      this.isShow = false
    }
  };


  //附加品項群組 查看 
  @ViewChild('EditAttachGMO_Tmp', { static: false }) EditAttachGMO_Tmp
  EditAttachGMO = {
    info: {
      ORG_Company_ID: null,
      ORG_Store_ID: null,
      GroupNo: null,
      moType: null,
      orgType:null,
    },
    isShow: false,
    data: {},
    onOpen: (type, data) => {
      let my = this.EditAttachGMO
      my.info = {
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: this.info.ORG_Store_ID,
        GroupNo: data ? data.PRDMenuAttachItemGroupNo ? data.PRDMenuAttachItemGroupNo : data.PRDAttachItemGroupNo  : null, 
        moType: type,
        orgType:this.info.orgType,
      }
      //事件會早於屬性匯入前執行 因此必須改使用參數
      //this.EditAttachMO_Tmp.onOpen(my.info,my.data)
      my.isShow = true
    },
    onSave: (data) => {
      if (data.ORG_Store_ID != this.ORG_Store_ID) {
        alert("群組門市需要與商品門市一致!")
        return
      }
    },
    onClose(v) {
      this.isShow = false
    }
  }


  //附加品項群組 刪除
  DelAttachG(index) {
    this.mealData.AttachItemGroupJsonDatas.splice(index, 1)
  }


  //取得使用中菜單檔 商品細項API
  getProductDetail(callback) {
    let par = {
      PRDGroupNo :this.info.PRDGroupNo, 
      PRDProductNo :this.info.PRDProductNo,
      ORG_Store_ID : this.info.ORG_Store_ID 
    }
    this.http
      .post<any>(
        "api/UsingMenu/GetProductDetail",par)
      .subscribe({
        next: (data) => {
          if (data.LIST.length > 0) {
            let obj = data.LIST[0]
            obj.PRDGroupNo = obj.PRDProductGroupNo
            this.toProductDetail(obj)
          }
        },
        error: (error) => {
          console.error("取得商品細項API error!", error);
        },
      });
  }


  //取得門市清單 API
  getStoreList() {//取得門市清單 
    this.http.post<any>('api/ORGStore/StoreList', {
      USR_AccountInfo_ID: this.USR_AccountInfo_ID,      
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: this.ORG_Store_ID,
    }).subscribe({
      next: data => {
        this.info.storeList = [];
        //門市共用下拉選單
        let Item :any= {};
        Item.value = 0;
        Item.content = '總部';
        this.info.storeList.push(Item);
    
        if(this.ORG_Store_ID ){
          //門市共用下拉選單
          let Item :any= {};
          Item.value = this.ORG_Store_ID;
          Item.content = data.LIST.find(x=>x.ORG_Store_ID == this.ORG_Store_ID ).StoreName;
          this.info.storeList.push(Item);
        }else{
          data.LIST.forEach(element => {
            //門市共用下拉選單
            var selectItem = new selectData();
            selectItem.value = element.ORG_Store_ID;
            selectItem.content = element.StoreName;
            this.info.storeList.push(selectItem);
          });
        }
      
        // 預設點第一個
        if (this.info.storeList.length > 0) {
          this.mealData.CopyStoreID = this.info.storeList[0].value
        }
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  //取得群組
  getGroupList(){

    if(this.info.orgType == 1){
      let par = {
        ORG_Company_ID: this.ORG_Company_ID,
        CreateStore: this.mealData.CopyStoreID == null ? 0 : this.mealData.CopyStoreID,
        IsDelete: false,
      }      
      this.http.post<any>('api/ProductSetting/GetProductGroup', par).subscribe({
        next: data => {
          this.info.groupList = []
          data.LIST.forEach(element => {
            let item = new selectData();
            item.value = element.PRDGroupNo;
            item.content = element.GroupName;
            this.info.groupList.push(item);
          });

          if(this.info.groupList.length>0)
            this.mealData.PRDGroupNo = this.info.groupList[0].value.toString() 

          this.info.isChange_Group = !this.info.isChange_Group
        },
        error: error => {
          console.error('There was an error!', error);
  
        }
      });

    }

  }

  trackByFn(i: number) {
    return i;
  }
}

class ModifyPRDProductReq {
  //商品
  PRDGroupNo: string; //
  PRDMenuProductGroupNo: string; //
  PRDProductNo: string; //  
  Main: any;
  Detail: any;
  USR_EmployeeInfo_ID: number; //
  USR_AccountInfo_ID: string; //
  ORG_Company_ID: number; //
  

  //---------------------------------main----------------------  
  ProductName: string; //
  ProductContant: string; //
  Image: string; // 
  TaxRate: number = 5; //
  TaxType: number = 2; //
  Cash: number; //

  //---------------------------------detail----------------------  
  SaleCash: number; //
  Sorting: number; //
  //2024.2.19 新增商品點餐方式(外帶/外送/內用/自取)預設開啟
  IsOpenTakeout: boolean = true;
  IsOpenDelivery: boolean = true;
  IsOpenDining: boolean = true;
  IsOpenReserveDining: boolean = false;
  IsOpenSelfPickup: boolean = true;
  IsChangeCash: boolean = true;//是否改價
  IsSumSubtotalQty: boolean = true;//計入小計數量
  SupplyQTY: number; //
  UplimitQTY: number; //
  SupplyDay: string; //供應日 用,區分，1:週一 2:週二 3:週三 4:週四 5:週五 6:週六 7:週日
  FirstSupplyStartTime: string; //
  FirstSupplyEndTime: string; //
  SecondSupplyStartTime: string; //
  SecondSupplyEndTime: string; // 
  AttachItemGroupJsonDatas: AttachItemGroupJsonDataDTO[];
  AttachItemGroupJsonData: string; //已存在的附加品項清單  用,分隔

  ProductLevelMapJsonData: ProductLevelMapJsonDataDTO[]; // 特殊價格設定

  //---------------------------------顯示用----------------------
  supplyPeriod?: Array<supplyPeriod>; //供應時段 
  supplyDayStr: string;
  supplyTimeMonday?: boolean;
  supplyTimeTuesday?: boolean;
  supplyTimeWednesday?: boolean;
  supplyTimeThursday?: boolean;
  supplyTimeFriday?: boolean;
  supplyTimeSaturday?: boolean;
  supplyTimeSunday?: boolean;
  files: ImageFile[] = [];

  //---------------------------------old----------------------
  ORG_Store_ID?: number; //
  CopyStoreID?: number; //複製用，目標商店ID

}

class supplyPeriod {
  startTime: Date;
  endTime: Date;
}

class AttachItemGroupJsonDataDTO {
  PRDMenuAttachItemGroupNo: string; //附加品項群組編號
  GroupName: string
  Content: string
  AttachItemKindName: string
  IsRequiredName: string
  Sorting:number
}

class ProductLevelMapJsonDataDTO{
  usrMemberLevelIDs: string;    //適用會員類型編號
  memberLevelNames: string;  //適用會員類型名字
  takeoutSaleCash: number;             //外帶會員售價
  deliverySaleCash: number;            //外送會員售價
  diningSaleCash: number;              //內用會員售價
  selfPickupSaleCash: number;          //自取會員售價
}

class ImageFile extends File {
  path: string;
}

class selectData {
  value: number; //
  content: string; //
}
class memberData {
  USR_MemberLevel_ID: string;
  MemberLevelName: string;
  isChecked: false;
}

